import { AbstractControl, AsyncValidatorFn, Validator, ValidatorFn, Validators } from '@angular/forms';

import { Observable } from 'rxjs/Rx';

export type ValidationResult = { [validator: string]: string | boolean };

export type AsyncValidatorArray = Array<Validator | AsyncValidatorFn>;

export type ValidatorArray = Array<Validator | ValidatorFn>;

const normalizeValidator =
  (validator: Validator | ValidatorFn): ValidatorFn | AsyncValidatorFn => {
    const func = (validator as Validator).validate.bind(validator);
    if (typeof func === 'function') {
      return (c: AbstractControl) => func(c);
    } else {
      return <ValidatorFn | AsyncValidatorFn>validator;
    }
  };

export const composeValidators =
  (validators: ValidatorArray): AsyncValidatorFn | ValidatorFn => {
    if (validators == null || validators.length === 0) {
      return null;
    }
    return Validators.compose(validators.map(normalizeValidator));
  };

export const validate =
  (validators: ValidatorArray, asyncValidators: AsyncValidatorArray) => {
    return (control: AbstractControl) => {
      const synchronousValid = () => composeValidators(validators)(control);

      // if (asyncValidators) {
      //   const asyncValidator = composeValidators(asyncValidators);

      //   return asyncValidator(control).map(v => {
      //     const secondary = synchronousValid();
      //     if (secondary || v) { // compose async and sync validator results
      //       return Object.assign({}, secondary, v);
      //     }
      //   });
      // }

      if (validators) {
        return Observable.of(synchronousValid());
      }

      return Observable.of(null);
    };
  };

export const message = (validator: ValidationResult, key: string): string => {
  switch (key) {
    case 'required':
      return 'Este campo é obrigatório.';
    case 'pattern':
      return 'O valor necessita de um formato específico.';
    case 'min':
      return `Necessário o mínimo de ${validator[key]['min']}`;
    case 'max':
      return `Necessário o máximo de ${validator[key]['max']}`;
    case 'minlength':
      return `Necessário o mínimo de ${validator[key]['requiredLength']} caracteres.`;
    case 'maxlength':
      return `Necessário o máximo de ${validator[key]['requiredLength']} caracteres.`;
      case'email':
      return 'Email inválido.';
  }

  
  switch (typeof validator[key]) {
    case 'string':
      return <string>validator[key];
    default:
      return validator[key] ? `Validação falhou, limite máximo excedido: ${validator[key]['requiredLength']}` : 'Valor do campo inválido.';
  }
};


// WEBPACK FOOTER //
// ./src/app/base/base-fields/form/validate.ts